"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var PlayIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/PlayIcon"));
var inline_icon_1 = tslib_1.__importDefault(require("../../inline-icon/inline-icon"));
var buttons_scss_1 = tslib_1.__importDefault(require("./buttons.scss"));
var withStyles_1 = require("../../../../common/utils/withStyles");
var currency_sign_1 = require("../../../../common/components/currency-sign");
var Buttons = /** @class */ (function (_super) {
    tslib_1.__extends(Buttons, _super);
    function Buttons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Buttons.prototype.getButtonClassNames = function () {
        var _a, _b, _c;
        var isRTL = this.props.isRTL;
        var buttonClassNames = classnames_1.default(buttons_scss_1.default.button, (_a = {},
            _a[buttons_scss_1.default.rtl] = isRTL,
            _a[buttons_scss_1.default.ltr] = !isRTL,
            _a));
        var iconClassNames = classnames_1.default(buttons_scss_1.default.icon, (_b = {},
            _b[buttons_scss_1.default.rtl] = isRTL,
            _b[buttons_scss_1.default.ltr] = !isRTL,
            _b));
        var textClassNames = classnames_1.default(buttons_scss_1.default.text, (_c = {},
            _c[buttons_scss_1.default.rtl] = isRTL,
            _c[buttons_scss_1.default.ltr] = !isRTL,
            _c));
        return {
            buttonClassNames: buttonClassNames,
            iconClassNames: iconClassNames,
            textClassNames: textClassNames,
        };
    };
    Buttons.prototype.renderPlayButton = function () {
        var _a = this.props, showPlayButton = _a.showPlayButton, playButtonText = _a.playButtonText, onPlayClick = _a.onPlayClick, isFocusable = _a.isFocusable;
        if (!showPlayButton) {
            return null;
        }
        var _b = this.getButtonClassNames(), buttonClassNames = _b.buttonClassNames, iconClassNames = _b.iconClassNames, textClassNames = _b.textClassNames;
        return (react_1.default.createElement("button", { className: buttonClassNames, onClick: onPlayClick, tabIndex: isFocusable ? 0 : -1, "aria-hidden": !isFocusable, role: "button", "aria-label": playButtonText, "data-hook": "overlay-play-button" },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(PlayIcon_1.default, null), className: iconClassNames }),
            react_1.default.createElement("div", { className: textClassNames }, playButtonText),
            this.renderTooltip(playButtonText)));
    };
    Buttons.prototype.renderBuyButton = function () {
        var _a = this.props, showBuyButton = _a.showBuyButton, buyButtonText = _a.buyButtonText, onBuyClick = _a.onBuyClick, isFocusable = _a.isFocusable, buyAriaLabel = _a.buyAriaLabel, currency = _a.currency;
        if (!showBuyButton) {
            return null;
        }
        var _b = this.getButtonClassNames(), buttonClassNames = _b.buttonClassNames, iconClassNames = _b.iconClassNames, textClassNames = _b.textClassNames;
        return (react_1.default.createElement("button", { className: buttonClassNames, onClick: onBuyClick, tabIndex: isFocusable ? 0 : -1, "aria-hidden": !isFocusable, role: "button", "aria-label": buyAriaLabel, "data-hook": "paid-access-button" },
            react_1.default.createElement("div", { className: classnames_1.default(buttons_scss_1.default.buyIcon, iconClassNames) },
                react_1.default.createElement(currency_sign_1.CurrencySign, { currency: currency })),
            react_1.default.createElement("div", { className: textClassNames }, buyButtonText),
            this.renderTooltip(buyButtonText)));
    };
    Buttons.prototype.renderTooltip = function (text) {
        var _a;
        var isRTL = this.props.isRTL;
        var classNames = classnames_1.default(buttons_scss_1.default.tooltip, (_a = {},
            _a[buttons_scss_1.default.rtl] = isRTL,
            _a[buttons_scss_1.default.ltr] = !isRTL,
            _a));
        return react_1.default.createElement("div", { className: classNames }, text);
    };
    Buttons.prototype.render = function () {
        var _a;
        var _b = this.props, showButtonsText = _b.showButtonsText, className = _b.className, isRTL = _b.isRTL;
        var buttonsClassName = classnames_1.default(buttons_scss_1.default.buttons, (_a = {},
            _a[buttons_scss_1.default['without-text']] = !showButtonsText,
            _a[buttons_scss_1.default.rtl] = isRTL,
            _a[buttons_scss_1.default.ltr] = !isRTL,
            _a), className);
        return (react_1.default.createElement("div", { className: buttonsClassName, "data-hook": "thumbnail-buttons" },
            this.renderPlayButton(),
            this.renderBuyButton()));
    };
    Buttons.propTypes = {};
    Buttons = tslib_1.__decorate([
        withStyles_1.withStyles(buttons_scss_1.default)
    ], Buttons);
    return Buttons;
}(react_1.default.Component));
exports.default = Buttons;
//# sourceMappingURL=buttons.js.map